import React from "react";
import "./footer.scss";
import Logo from "../../../public/img/ale-baja-logo-white.svg";
import { useNavigate } from "react-router-dom";

function Footer() {
    const navigate = useNavigate();

    return (
        <div>
            <footer className="footer">
                <div className="footer__logo-box">
                    <img
                        className="footer__logo"
                        onClick={() => {
                            window.scrollTo(0, 0);
                            navigate("/");
                        }}
                        alt="Footer-logo"
                        src={Logo}
                    />
                </div>
                <div className="row">
                    <p className="footer__copyright">
                        Copyright &copy; 2025 alebaja.com.pl
                    </p>
                </div>
            </footer>
        </div>
    );
}

export default Footer;
